import DesignShell from '../components/DesignShell';

const CARDS = [
  {
    to: '/setup',
    title: 'Site Setup',
    desc: 'How this master-record site is built and hosted — the Azure resources in CIPD Production (BYOFA), the deploy pipelines, the required variable group, cross-subscription RBAC, and where things live in the repo.',
  },
  {
    to: '/workflow-promotion',
    title: 'Workflow Promotion',
    desc: 'The end-to-end path for shipping a workflow across the estates — build/edit in the Logic App designer, sync back to the repo, review and merge, deploy, publish content, and promote through the environments, with approvals and common pitfalls.',
  },
  {
    to: '/site/pipelines',
    title: 'ADO Pipelines',
    desc: 'Reference for every Azure DevOps pipeline that builds or deploys the platform — infrastructure, application, and the master-record site — plus the publish-chain ordering and naming conventions.',
  },
];

export default function SitePage() {
  return (
    <DesignShell
      title="Site"
      subtitle="How the Synergy master-record site is set up, how workflows are promoted across the estates, and the ADO pipelines that build and deploy everything."
    >
      <p>
        This section covers the operational and delivery side of the platform site — setup
        and hosting, the workflow promotion lifecycle, and the pipeline reference. Open any
        area below.
      </p>
      <div className="design-cards">
        {CARDS.map((c) => (
          <a
            key={c.to}
            href={`#${c.to}`}
            target="_blank"
            rel="noopener noreferrer"
            className="design-hub-card"
          >
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </a>
        ))}
      </div>
    </DesignShell>
  );
}
